import { render, staticRenderFns } from "./bomunexport.vue?vue&type=template&id=f353230a&scoped=true&"
import script from "./bomunexport.vue?vue&type=script&lang=js&"
export * from "./bomunexport.vue?vue&type=script&lang=js&"
import style0 from "./bomunexport.vue?vue&type=style&index=0&id=f353230a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f353230a",
  null
  
)

export default component.exports